<template>
  <v-container
    id="users"
    fluid
    tag="section"
  >
    <base-v-component
      heading="Users"
      link="users/list"
    />

    <base-material-card
      icon="mdi-account"
      title="Registered Users"
      class="px-5 py-3"
    >
      <v-simple-table>
       <thead>
  <tr>
                        <th>email</th>
                        <th>First Name</th>


        <th>Last Name</th>
                        <th>Age</th>
                         <th>City</th>
                          <th>State</th>
                        <th>Zip Code</th>
                    </tr>        </thead>

        <tbody>
  <tr v-for="user in Users" :key="user.key">
                        <td>{{ user.email }}</td>
                        <td>{{ user.firstname }}</td>
                         <td>{{ user.lastname }}</td>
                          <td>{{ user.age }}</td>
                          <td>{{ user.city }}</td>
                           <td>{{ user.state }}</td>
                            <td>{{ user.zip }}</td>
                        
                        <td>
                            <router-link :to="{name: 'profile', params: { id: location.key }}" class="btn btn-primary">Profile
                            </router-link>
                          
                        </td>
                    </tr>        </tbody>

      </v-simple-table>
    </base-material-card>

</template>
<script>
    import { db } from '../../../firebaseDb';
    
    export default {
        data() {
            return {
                Users: []
            }
        },
        created() {
            db.collection('Users').onSnapshot((snapshotChange) => {
                this.Users = [];
                snapshotChange.forEach((doc) => {
                    this.Users.push({
                        key: doc.id,
                        email: doc.data().email,
                         firstname: doc.data().firstname,
                          lastname: doc.data().lastname,
                           age: doc.data().age,
                            city: doc.data().city,
                             state: doc.data().state,
                              zip: doc.data().zip,
                       
                    })
                });
            })
        },
        methods: {
            
        }
    }
</script>


